export const STATUS_DISCONTINUED = 'discontinued'
